import { ImageProps } from 'src/components/image';
import { i18n } from 'src/i18n';

import arrowLeftWhite from './arrow-left-white.svg';
import altiboxLogo from './altibox-logo.png';
import arrowLeft from './arrow-left.svg';
import buildingIcon from './building.svg';
import cellTowerIcon from './cell-tower.svg';
import chevronRightDisabled from './chevron-right-disabled.svg';
import chevronRight from './chevron-right.svg';
import clockIcon from './clock.svg';
import emailIcon from './email.svg';
import errorIcon from './error.svg';
import exclamationMarkIcon from './exclamation-mark.svg';
import gamingIcon from './gaming.svg';
import heartIcon from './heart.svg';
import houseIcon from './house.svg';
import infoIcon from './info.svg';
import logoHorizontal from './logo-desktop.svg';
import logoVertical from './logo-mobile.svg';
import mapPinIcon from './map-pin.svg';
import monkeyIcon from './monkey.svg';
import owlIcon from './owl.svg';
import personIcon from './person.svg';
import phoneIcon from './phone.svg';
import serverIcon from './server.svg';
import tvIcon from './tv.svg';
import wifiIcon from './wifi.svg';

export const monkeyImageProps: ImageProps = {
  src: monkeyIcon,
  alt: i18n.image.monkey,
};

export const owlImageProps: ImageProps = {
  src: owlIcon,
  alt: i18n.image.owl,
};

export const logoVerticalImageProps: ImageProps = {
  src: logoVertical,
  alt: i18n.image.logo,
};

export const logoHorizontalImageProps: ImageProps = {
  src: logoHorizontal,
  alt: i18n.image.logo,
};

export const arrowLeftImageProps: ImageProps = {
  src: arrowLeft,
  alt: i18n.image.arrowLeft,
};

export const arrowLeftWhiteImageProps: ImageProps = {
  src: arrowLeftWhite,
  alt: i18n.image.arrowLeft,
};

export const chevronRightImageProps: ImageProps = {
  src: chevronRight,
  alt: i18n.image.chevronRight,
};

export const chevronRightDisabledImageProps: ImageProps = {
  src: chevronRightDisabled,
  alt: i18n.image.chevronRight,
};

export const errorImageProps: ImageProps = {
  src: errorIcon,
  alt: i18n.image.error,
};

export const infoImageProps: ImageProps = {
  src: infoIcon,
  alt: i18n.image.info,
};

export const gamingImageProps: ImageProps = {
  src: gamingIcon,
  alt: i18n.image.gaming,
};

export const phoneImageProps: ImageProps = {
  src: phoneIcon,
  alt: i18n.image.phone,
};

export const tvImageProps: ImageProps = {
  src: tvIcon,
  alt: i18n.image.tv,
};

export const wifiImageProps: ImageProps = {
  src: wifiIcon,
  alt: i18n.image.wifi,
};

export const houseImageProps: ImageProps = {
  src: houseIcon,
  alt: i18n.image.house,
};

export const personImageProps: ImageProps = {
  src: personIcon,
  alt: i18n.image.person,
};

export const buildingImageProps: ImageProps = {
  src: buildingIcon,
  alt: i18n.image.building,
};

export const emailImageProps: ImageProps = {
  src: emailIcon,
  alt: i18n.image.email,
};

export const heartImageProps: ImageProps = {
  src: heartIcon,
  alt: i18n.image.heart,
};

export const mapPinImageProps: ImageProps = {
  src: mapPinIcon,
  alt: i18n.image.mapPin,
};

export const serverImageProps: ImageProps = {
  src: serverIcon,
  alt: i18n.image.server,
};

export const exclamationMarkProps: ImageProps = {
  src: exclamationMarkIcon,
  alt: i18n.image.exclamationMark,
};

export const altiboxImageProps: ImageProps = {
  src: altiboxLogo,
  alt: i18n.image.altibox,
};

export const cellTowerImageProps: ImageProps = {
  src: cellTowerIcon,
  alt: i18n.image.fixedWirelessAccess,
};

export const clockImageProps: ImageProps = {
  src: clockIcon,
  alt: i18n.image.clockIcon,
};
